module.exports = __webpack_public_path__ + "img/search-lg.f421df9e.svg";